document.addEventListener("DOMContentLoaded", () => {
  const dropdownItems = document.querySelectorAll(".header__nav-item.dropdown");

  if (dropdownItems.length > 0) {
    dropdownItems.forEach((item) => {
      item.addEventListener("click", (e) => {
        const isAnchor = e.target.tagName === "A";

        if (isAnchor && item.contains(e.target) && e.target.classList.contains('header__nav-link')) {
          e.preventDefault();
        }

        item.classList.toggle("active");

        dropdownItems.forEach((otherItem) => {
          if (otherItem !== item) {
            otherItem.classList.remove("active");
          }
        });

        e.stopPropagation();
      });
    });

    document.addEventListener("click", () => {
      dropdownItems.forEach((item) => item.classList.remove("active"));
    });
  }
});
